import {axios, createAsyncThunk} from '../thunk-config'

export default createAsyncThunk('payment/addOrder', async ({order, customerInfo, headers}, {rejectWithValue}) => {
  try {
    const {connection_id, campaign_id, offers, merchant_id, customer_id, customers_address_billing_id, customers_address_shipping_id, cart_token, gift_cards, payment_token, payment_method_id, shipping_profile_id} = order

    const orderSubmission = {
      connection_id,
      campaign_id,
      offers: offers ? offers.map(offer => ({
        id: offer.id,
        campaign_id: order.campaign_id,
        offer_id: offer.offer_id,
        order_offer_id: null,
        order_offer_quantity: offer.order_offer_quantity,
        order_offer_price: offer.order_offer_price,
        discount_code: offer.discount_code,
        parent_order_offer_id: offer.parent_order_offer_id,
        order_offer_item_options: offer.order_offer_item_options,
        item_id: offer.item_id,
        override_initial_item_id: offer.override_initial_item_id,
        override_initial_item_options: offer.override_initial_item_options,
        field_id: offer.id ? `cart_offer_${offer.id}` : null,
        is_gift: offer.is_gift,
        gift_message: offer.gift_message,
        gift_name: offer.gift_name,
        gift_date: offer.gift_date,
        gift_phone: offer.gift_phone,
        gift_email: offer.gift_email
      })) : null,
      merchant_id,
      customer_id,
      customers_address_billing_id,
      customers_address_shipping_id,
      cart_token,
      gift_cards,
      shipping_profile_id,
      session_id: order.cart_token,
      referral_token: order.referral_token,
      payment_token,
      payment_method_id
    }

    if(order.order_id) {
      orderSubmission.order_id = order.order_id
    }

    const response = await axios.post('/utilv2/add_order', {
      ...orderSubmission,
      ...customerInfo
    }, {headers})

    if(response.data.data) {
      return {order_id: response.data.data.id, customers_address_shipping_id: response.data.data.customers_address_shipping_id}
    } else {
      return rejectWithValue({message: 'Internal server error', data: response.data})
    }
  } catch(err) {
    if(!err.response) {
      throw err
    }

    return rejectWithValue(err.response.data)
  }
})


// WEBPACK FOOTER //
// ./client/resources/js/checkout/redux/thunks/addOrder.js